export const BASIC_SHIPMENT_INFO = {
  groups: [],
  columns: [
    'order_carrier_name',
    'mode',
    'move_type',
    'marketCode',
    'shipment_origin',
    'shipment_origin_name',
    'shipment_origin_city',
    'shipment_origin_state',
    'shipment_destination',
    'shipment_destination_name',
    'shipment_destination_city',
    'shipment_destination_state',
    'shipment_id',
    'shipmentStatus',
    'order_id',
    'order_type',
    'shipper_name',
    'carrier_name',
    'shipment_type',
  ],
};

export const DOCUMENTS = {
  columns: ['pod_status', 'has_required_docs', 'is_pod_valid'],
};

export const CHARGES_AND_ACCESSORIALS = {
  columns: ['base_rate', 'chassis', 'detention', 'storage', 'other', 'total'],
};

export const DATES_MILESTONES = {
  columns: [
    'discharge_date',
    'lfd',
    'yard_lfd',
    'created_at',
    'review_date',
    'accounting_review_date',
    'eta',
    'available_date',
    'outgated_date',
    'empty_returned_date',
    'empty_ready_for_pickup',
    'last_cut_date',
    'earliest_return_date',
    'earliest_empty_date',
    'arrived_date',
    'days_since_loaded_delivery',
    'days_since_loaded_delivery_bin',
    'last_free_date_bin',
    'combo_outgated_date',
    'combo_last_free_date',
    'outgated',
    'empty_returned',
    'rail_loaded',
    'rail_departed',
    'rail_arrived_at_facility',
    'rail_unloaded',
    'rail_available_at_facility',
    'rail_outgated_from_facility',
    'rail_lfd_at_facility',
    'rail_eta_final_facility',
    'rail_ingated_at_origin_facility',
    'rail_loaded_at_origin',
    'rail_departed_from_origin',
    'rail_arrived_at_destination_port_facility',
    'rail_unloaded_at_destination_port',
    'empty_rail_billing',
    'loaded_rail_billing',
    'must_arrive_by_date',
    'requested_pickup_date',
    'requested_delivery_appointment',
    'per_diem_lfd',
    'document_cutoff_date',
    'rail_earliest_return',
    'rail_cut_date',
  ],
};

export const BILLING = {
  columns: [
    'shipperCost',
    'carrierCost',
    'vendorCost',
    'margin',
    'shipment_automated_billing_status_evaluation_paused',
    'shipment_automated_billing_status_evaluation_reason_code',
    'shipment_automated_billing_status_evaluation_paused_timestamp',
  ],
};

export const OCEAN = {
  columns: [
    'steamship_or_railroad',
    'opentrack_container_status',
    'opentrack_container_status_2',
    'opentrack_tracking_status',
    'container_status',
    'has_rail_events',
  ],
};

export const TEAM = {
  columns: [
    'shipper_operations_group',
    'shipper_operations_manager',
    'team',
    'commercial_sales_rep',
    'commercial_account_manager',
    'drayage_ops_customer_success',
    'shorthaul_ops_operations_manager',
  ],
};

export const RAIL = { columns: ['train'] };

export const REFERENCE_AND_NOTES = {
  columns: [
    'admin_notes',
    'notes',
    'cargo_description',
    'reference_numbers',
    'tags',
    'pickup_number',
    'so_number',
    'comments',
    'delivery_order',
    'gate_dropoff',
    'gate_pickup',
    'house_bill_number',
    'isa',
    'master_bol',
    'mg_load_id',
    'mo_number',
    'pu_number',
    'seal_number',
    'tracking_id',
    'truck_order',
    'VRID',
    'work_order_number',
    'last_move',
    'final_destination',
    'position',
    'cargo_weight',
    't_state',
    'freight_kind',
    'over_weight',
    'reqs_power',
    'unit_impediments',
    'booking_number',
    'partnerShipmentId',
  ],
};

export const SHIPMENT_DETAILS = {
  columns: [
    'hazmat_description',
    'hazmat_class',
    'originating',
    'service_type',
    'hazmat_packaging_group',
    'total_weight',
    'master_bol_status',
    'orderStatus',
    'delivery_order_status',
    'bco',
    'vessel_or_rail',
    'on_hold_reason',
    'exposed',
  ],
};

export const columnCategoriesMap = {
  basic_shipment_info: BASIC_SHIPMENT_INFO,
  documents: DOCUMENTS,
  charges_and_accessorials: CHARGES_AND_ACCESSORIALS,
  dates_and_milestones: DATES_MILESTONES,
  finance_and_billing: BILLING,
  ocean_tracking: OCEAN,
  rail_tracking: RAIL,
  team: TEAM,
  reference_and_notes: REFERENCE_AND_NOTES,
  shipment_details: SHIPMENT_DETAILS,
};
